import { ControlledTextField, FieldsetCard, FormContainer, useFormContainerContext } from '@if/mui'
import { usePostNote } from '@src/data/api/credit-api/credit-api'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { NotebookPen } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: CreditApplication
}

interface FormValues {
  note: string
}

const MAX_NOTE_LENGTH = 2000

const NoteField = () => {
  const { t } = useTranslation()
  const { methods } = useFormContainerContext<FormValues>()

  return (
    <ControlledTextField
      control={methods.control}
      name="note"
      multiline
      minRows={5}
      placeholder={t('notes.placeholder')}
      slotProps={{ htmlInput: { maxLength: MAX_NOTE_LENGTH } }}
    />
  )
}

const NotesCard = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [postNote] = usePostNote()

  return (
    <FormContainer<FormValues>
      mode="autosave"
      useFormSetup={() => ({ defaultValues: { note: creditApp.note ?? '' } })}
      onSubmit={async ({ note }) => {
        await postNote({
          creditApplicationId: creditApp.id,
          financingProgramId: creditApp.financingProgramId,
          noteDto: { note, versionTag: creditApp.versionTag ?? '' },
        })
      }}
    >
      <FieldsetCard icon={NotebookPen} title={t('notes.title')} subtitle={t('notes.subtitle')}>
        <NoteField />
      </FieldsetCard>
    </FormContainer>
  )
}

export default NotesCard
